import React from "react";
import styled from "styled-components";
import theme from "../../../../theme/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faQuestionCircle,
  faDotCircle,
} from "@fortawesome/free-solid-svg-icons";

const HelpWrapper = styled.div`
  text-align: left;
  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .needHelp {
    margin-top: 50px;
    @media (max-width: 480px) {
      display: flex;
      flex-direction: column;
      text-align: center;
    }

    .primaryText {
      font-size: 25px;
      font-weight: 800;
    }

    .secondaryText {
      font-size: 20px;
      font-weight: 600;
    }
  }

  .points {
    margin-top: 50px;

    .pointItem {
      margin-top: 10px;
    }
  }

  .advisorButton {
    margin-top: 50px;
    display: flex;
    gap: 10px;

    .button {
      display: block;
      width: 70%;
      color: white;
      font-size: 15px;
      font-weight: 700;
      padding: 45px 0px;
      border: none;
      background: ${theme.colors.primaryStrong2X};
      border-radius: 4px;

      cursor: pointer;
      @media (max-width: 480px) {
        width: 100%;
        padding: 35px 0px;
      }
    }
    @media (max-width: 480px) {
      width: 100%;
    }
  }
`;

const Help = () => {
  const handleContactAdvisorClick = () => {
    window.open(
      "https://tactivewealth.com/connect-with-a-wealth-advisor/",
      "_blank"
    );
  };

  const handleContactSupportClick = () => {
    window.open(
      "https://tactivewealth.com/tactive-account-support-form/",
      "_blank"
    );
  };

  return (
    <HelpWrapper>
      <div className="icon">
        <FontAwesomeIcon style={{ fontSize: "50px" }} icon={faQuestionCircle} />
      </div>
      <div className="needHelp">
        <div className="primaryText">Need help with your account?</div>
        <div className="secondaryText">This could include changes to:</div>
      </div>
      <div className="points">
        <div className="pointItem">
          <FontAwesomeIcon icon={faDotCircle} /> Bank Details
        </div>
        <div className="pointItem">
          <FontAwesomeIcon icon={faDotCircle} /> Personal Information
        </div>
        <div className="pointItem">
          <FontAwesomeIcon icon={faDotCircle} /> Closing your account
        </div>
      </div>
      <div className="advisorButton">
        <button onClick={handleContactSupportClick} className="button">
          Contact Support
        </button>
        <button onClick={handleContactAdvisorClick} className="button">
          Contact Advisor
        </button>
      </div>
    </HelpWrapper>
  );
};

export default Help;
